/**
 *
 * Configuration
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import reducer from "./reducer"
import saga from "./saga"

import questionIcon from "../../../images/question.svg"
import warningIcon from "../../../images/warning.svg"
import ModalRankSignaling from "components/ModalRankSignaling"

import { getConfigurationWatcher, putConfigurationWatcher } from "./actions"
import {
  makeSelectConfigurationObject,
  makeSelectIsLoadingConfiguration,
} from "./selectors"

import Loader from "components/Loader"

import { map, values, isEqual } from "lodash"
import { InputNumber, Divider, Popover, Button, Switch } from "antd"
import "./index.less"
import {
  isModeInModuleBySlug,
  isModuleBySlug,
  KEY_ANONYMITY,
  KEY_ANONYMITY_LEADERS,
  setItem,
} from "../../../utils/storage"
import {
  ACTION_PLANS,
  AMBASSADOR_USERS,
  CUSTOM_INDICATORS,
  DISABLE,
  QUALITATIVE_FEEDBACK,
} from "../../../utils/constants"
import { LOCAL_PDA_IA_ENABLED } from "../../../utils/storage"

import { buttonAction_btns } from "../../../components/Snowplow/config2"
import beta from "images/beta.svg"

/* eslint-disable react/prefer-stateless-function */
export class Configuration extends React.Component {
  state = {
    modalRankSignaling: false,
    boxSelected: {},
    leadership_anonymity: 0,
    working_environment_anonymity: 0,
    improvement_opportunity_threshold: 0,
    ambassador_qualitative_results_visible: false,
    ambassador_benchmark_visible: false,
    boxs: [],
    loadingPage: true,
  }

  componentDidMount = () => {
    this.props.getConfigurationWatcher()
    setTimeout(() => {
      this.setState({ loadingPage: false })
    }, 1500)
  }

  setStateFrom = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  componentDidUpdate = (prevProps) => {
    const isLoading = !isEqual(
      prevProps.isLoadingConfiguration,
      this.props.isLoadingConfiguration
    )

    if (isLoading && !this.props.isLoadingConfiguration) {
      this.setStateFromProps()
    }
  }

  setStateFromProps = () => {
    const configurationClone = JSON.parse(
      JSON.stringify(this.props.configuration)
    )
    const {
      improvement_opportunity_threshold,
      leadership_anonymity,
      working_environment_anonymity,
      report_color_range,
      ambassador_qualitative_results_visible,
      ambassador_benchmark_visible,
    } = configurationClone

    this.setState({
      leadership_anonymity,
      working_environment_anonymity,
      improvement_opportunity_threshold,
      ambassador_qualitative_results_visible,
      boxs: report_color_range,
      ambassador_benchmark_visible,
    })
  }

  renderBoxs = () => {
    const { boxSelected, boxs } = this.state
    
    return map(boxs, ({ rgb, start, finish, id, disabled }) => {
      if (!disabled) {
        return (
          <div
            key={id}
            className="container-configuration__box"
            onClick={() => {
              if (disabled) return

              this.setState({
                modalRankSignaling: true,
                boxSelected: { rgb, start, finish, id },
              })
              buttonAction_btns(
                "Cuadrado Semaforización de rangos para resultados Top two box"
              )
            }}>
            <div
              className={`
                container-configuration__box-color ${
                  boxSelected.id == id ? "box-active" : ""
                }
                ${disabled ? "box-desactive" : ""}
              `}
              style={{ backgroundColor: `rgb(${values(rgb).join(", ")})` }}
            />
            {!disabled && (
              <div className="container-configuration__box-footer">
                <span>{start}</span>
                <span>a</span>
                <span>{finish}%</span>
              </div>
            )}
          </div>
        )
      }
    })
  }

  validateChangeFooter = () => {
    const {
      leadership_anonymity,
      working_environment_anonymity,
      improvement_opportunity_threshold,
      ambassador_qualitative_results_visible,
      ambassador_benchmark_visible,
    } = this.props.configuration
    const stateContent = {
      leadership_anonymity: this.state.leadership_anonymity,
      working_environment_anonymity: this.state.working_environment_anonymity,
      improvement_opportunity_threshold: this.state
        .improvement_opportunity_threshold,
      ambassador_qualitative_results_visible: this.state
        .ambassador_qualitative_results_visible,
      ambassador_benchmark_visible: this.state.ambassador_benchmark_visible,
    }

    const propsContent = {
      leadership_anonymity,
      working_environment_anonymity,
      improvement_opportunity_threshold,
      ambassador_qualitative_results_visible,
      ambassador_benchmark_visible,
    }

    return !isEqual(stateContent, propsContent)
  }

  restoreColors = () => {
    const { configuration } = this.props
    const data = map(this.state.boxs, (item, index) => {
      return {
        ...item,
        rgb: configuration.default.report_color_range[index].rgb,
      }
    })

    this.setState({ boxs: data })
  }

  render() {
    const {
      loadingPage,
      ambassador_qualitative_results_visible,
      ambassador_benchmark_visible,
    } = this.state
    const isFreemium = window.freemium()

    const isQualitativeFeedbackModule = isModuleBySlug(QUALITATIVE_FEEDBACK)

    const leadershipContent = (
      <div className="container-configuration___leadershipContent">
        <span>Cantidad mínima</span> de personas que deben existir en un{" "}
        <span>equipo </span>
        para poder medir el estilo liderazgo del jefe. No puede ser menor a 2.
      </div>
    )

    const climaContent = (
      <div className="container-configuration___leadershipContent">
        <span>Cantidad mínima</span> de respuestas que deben existir en una{" "}
        <span>división </span>
        para mostrar los resultados. No puede ser menor a 3.
      </div>
    )

    const anonymity = () => {
      return (
        <div>
          <h4>Anonimato</h4>
          <p className="container-configuration__description">
            <span>Cantidad mínima</span> de respuestas que deben existir en una
            <span> división</span> o <span>equipo</span> para mostrar los
            resultados.
          </p>
          <div className="container-configuration__item">
            <span>
              Clima laboral y Engagement
              <Popover placement="topRight" content={climaContent}>
                <img src={questionIcon} alt="question-icon" />
              </Popover>
            </span>
            <InputNumber
              min={3}
              max={100}
              step={1}
              value={this.state.working_environment_anonymity}
              onChange={(e) => {
                if (typeof e === "object")
                  return this.setStateFrom("working_environment_anonymity", 3)
                setItem(KEY_ANONYMITY, e)
                this.setStateFrom("working_environment_anonymity", e)
              }}
              formatter={(value) => {
                if (!value || isNaN(parseInt(value))) return ""
                return parseFloat(value).toFixed(0)
              }}
            />
          </div>
          <div
            className="container-configuration__item"
            style={{ marginTop: 10 }}>
            <span>
              Liderazgo
              <Popover placement="topRight" content={leadershipContent}>
                <img src={questionIcon} alt="question-icon" />
              </Popover>
            </span>
            <InputNumber
              min={2}
              max={100}
              step={1}
              value={this.state.leadership_anonymity}
              onChange={(e) => {
                if (typeof e === "object")
                  return this.setStateFrom("leadership_anonymity", 2)
                setItem(KEY_ANONYMITY_LEADERS, e)
                return this.setStateFrom("leadership_anonymity", e)
              }}
              formatter={(value = 2) => {
                if (!value || isNaN(parseInt(value))) return ""
                return parseFloat(value).toFixed(0)
              }}
            />
          </div>

          <Divider />
        </div>
      )
    }

    if (loadingPage) return <Loader height="80vh" />
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    const actionPlansModule = isModeInModuleBySlug(ACTION_PLANS)
    const isCustomIndicatorsEnabled = isModuleBySlug(CUSTOM_INDICATORS)

    return (
      <div className="container-configuration">
        {!isCustomIndicatorsEnabled && anonymity()}

        {LOCAL_PDA_IA_ENABLED() && (
          <Fragment>
            <div
              className="container-configuration__item"
              style={{ marginTop: 10 }}>
              <h4 style={{ display: "inline-block", width: 283 }}>
                Sugerencias con inteligencia artificial: Límite
                
              </h4>
              <img
                            src={beta}
                            style={{ marginLeft: 8,marginRight: 28 }}
                            alt="beta"
                          />
              <InputNumber
                min={0}
                max={100}
                step={1}
                value={this.state.improvement_opportunity_threshold}
                parser={(value) => value.replace("%", "")}
                onChange={(e) => {
                  buttonAction_btns(
                    "Configuracion Caja de texto Oportunidad de mejora"
                  )
                  if (typeof e === "object")
                    return this.setStateFrom(
                      "improvement_opportunity_threshold",
                      0
                    )
                  return this.setStateFrom(
                    "improvement_opportunity_threshold",
                    e
                  )
                }}
                formatter={(value = 0) => {
                  if (!value || isNaN(parseInt(value))) return ""
                  return `${parseFloat(value).toFixed(0)}%`
                }}
              />

              <p
                className="container-configuration__description"
                style={{ fontSize: 13,width: 670 }}>
                Si el resultado obtenido de la dimensión es igual o menor al valor establecido, el sistema creará de planes de acción con inteligencia artificial para el usuario embajador.
              </p>
            </div>
            <Divider />
          </Fragment>
        )}

        <h4>
          Semaforización de rangos para resultados &#8220;Top two box&#8221;
        </h4>
        <p
          className="container-configuration__description"
          style={{ fontSize: 13 }}>
          Selecciona los colores y rangos de preferencia para la visualización
          de resultados en los Reportes de indicadores con cálculos de tipo “Top
          two box”.
        </p>
        <div className="container-configuration__boxs">{this.renderBoxs()}</div>
        <p
          className="container-configuration__description"
          style={{ fontSize: 13 }}>
          <span>Nota: </span>
          Los cambios en la visualización de colores se actualizarán al
          producirse el próximo reprocesamiento de métricas.
        </p>

        {isAmbassador && (
          <>
            <Divider />
            <h4>Embajadores</h4>
            <div
              className="container-reminderemails__item"
              style={{ marginTop: 8 }}>
              <Switch
                checked={ambassador_qualitative_results_visible}
                onChange={(e) => {
                  this.setStateFrom("ambassador_qualitative_results_visible", e)
                  buttonAction_btns(
                    "Switch Visualización comentarios cualitativos"
                  )
                }}
              />
              <div>
                <div className="container-reminderemails__item-title">
                  Visualización comentarios cualitativos
                </div>
                <p>
                  Los embajadores podrán visualizar las respuestas a las
                  preguntas cualitativas <b>de forma anónima</b> de los
                  colaboradores pertenecientes a su división y divisiones
                  inferiores.
                </p>
              </div>
            </div>
          </>
        )}

        {isAmbassador && (
          <>
            <Divider />
            <h4>Benchmark</h4>
            <div
              className="container-reminderemails__item"
              style={{ marginTop: 8 }}>
              <Switch
                checked={ambassador_benchmark_visible}
                onChange={(e) =>
                  this.setStateFrom("ambassador_benchmark_visible", e)
                }
              />
              <div>
                <div className="container-reminderemails__item-title">
                  Visualización embajadores
                </div>
                <p>
                  Los embajadores podrán visualizar el benchmark Mandü en sus
                  reportes.
                </p>
              </div>
            </div>
          </>
        )}

        {this.validateChangeFooter() && (
          <div className="container-configuration__actions">
            <Button onClick={this.setStateFromProps}>Cancelar</Button>
            <Button
              loading={this.props.isLoadingConfiguration}
              type="primary"
              onClick={() => {
                this.props.putConfigurationWatcher({
                  leadership_anonymity: this.state.leadership_anonymity,
                  working_environment_anonymity: this.state
                    .working_environment_anonymity,
                  improvement_opportunity_threshold: this.state
                    .improvement_opportunity_threshold,
                  ambassador_qualitative_results_visible: ambassador_qualitative_results_visible
                    ? 1
                    : 0,
                  ambassador_benchmark_visible: ambassador_benchmark_visible
                    ? 1
                    : 0,
                })
              }}>
              Guardar
            </Button>
          </div>
        )}

        <ModalRankSignaling
          restoreColors={this.restoreColors}
          putConfigurationWatcher={this.props.putConfigurationWatcher}
          getConfigurationWatcher={this.props.getConfigurationWatcher}
          configuration={this.props.configuration}
          boxsItems={this.state.boxs}
          boxs={this.renderBoxs()}
          boxSelected={this.state.boxSelected}
          visible={this.state.modalRankSignaling}
          stateStateFrom={this.setStateFrom}
        />
      </div>
    )
  }
}

Configuration.propTypes = {}

const mapStateToProps = createStructuredSelector({
  configuration: makeSelectConfigurationObject(),
  isLoadingConfiguration: makeSelectIsLoadingConfiguration(),
})

function mapDispatchToProps(dispatch) {
  return {
    getConfigurationWatcher: () => dispatch(getConfigurationWatcher()),
    putConfigurationWatcher: (params) =>
      dispatch(putConfigurationWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "configuration", reducer })
const withSaga = injectSaga({ key: "configuration", saga })

export default compose(withReducer, withSaga, withConnect)(Configuration)
